export const useEditorPanelExpansion = ({ expanded, setExpanded }) => {
  const handleChange = (panel) => () => {
    switch (panel) {
      case "panel1":
        setExpanded({ ...expanded, panel1: !expanded.panel1 });
        break;
      case "panel2":
        setExpanded({ ...expanded, panel2: !expanded.panel2 });
        break;
      case "panel3":
        setExpanded({ ...expanded, panel3: !expanded.panel3 });
        break;
      case "panel4":
        setExpanded({ ...expanded, panel4: !expanded.panel4 });
        break;
      case "panel5":
        setExpanded({ ...expanded, panel5: !expanded.panel5 });
        break;
      case "panel6":
        setExpanded({ ...expanded, panel6: !expanded.panel6 });
        break;
      case "panel7":
        setExpanded({ ...expanded, panel7: !expanded.panel7 });
        break;
      case "panel8":
        setExpanded({ ...expanded, panel8: !expanded.panel8 });
        break;
      case "panel9":
        setExpanded({ ...expanded, panel9: !expanded.panel9 });
        break;
      case "panel10":
        setExpanded({ ...expanded, panel10: !expanded.panel10 });
        break;
      case "panel11":
        setExpanded({ ...expanded, panel11: !expanded.panel11 });
        break;
      case "panel12":
        setExpanded({ ...expanded, panel12: !expanded.panel12 });
        break;
      case "panel13":
        setExpanded({ ...expanded, panel13: !expanded.panel13 });
        break;
      default:
        break;
    }
  };

  return { handleChange };
};
